<!-- DeleteTaskComponent template -->
<mat-dialog-content>
  <!-- Your dialog content goes here -->
  <div class="modal-header">
    <h5 class="modal-title ">
      Enter Order Address
    </h5>
  </div>
  <div class="modal-body  ">
    <geoapify-geocoder-autocomplete class="form-group" (placeSelect)="onPlaceSelected($event)"></geoapify-geocoder-autocomplete>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="reserve()"
    >
      Send
    </button>
    <button
      type="button"
      class="btn btn-secondary"
      (click)="close()"
    >
      Close
    </button>

  </div>
</mat-dialog-content>
